import React, { useState, useEffect, useRef } from "react";
import { useModals } from "@mantine/modals";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { NumberInput, Radio, Select, Stepper, List, Text, Button } from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { Modal } from "@mantine/core";
import { ReactComponent as Logo } from "../../assets/logo.svg";
import { ReactComponent as Back } from "../../assets/modalBackIcon.svg";
import { ReactComponent as Close } from "../../assets/modalCloseIcon.svg";
import { ReactComponent as CheckIcon } from "../../assets/Check.svg";
import { ReactComponent as SelectIcon } from "../../assets/fi-rr-angle-small-down.svg";
import { ReactComponent as UploadIcon } from "../../assets/humbleicons_upload.svg";
import { ReactComponent as CircleTickIcon } from "../../assets/circle_tick.svg";


import "../home/components/checkEligibility/modal/eligibilityModal.css";
import CustomButton from "../../components/CustomButton";
import TravelerInformation from "../home/components/checkFileaClaim/modal/steppers/TravelerInformation";
import SaveOrContinueAsGuest from "../home/components/checkFileaClaim/modal/steppers/SaveOrContinueAsGuest";
import ClaimDetails from "../home/components/checkFileaClaim/modal/steppers/ClaimDetails";
import OriginallyBookedFlights from "../home/components/checkFileaClaim/modal/steppers/OriginallyBookedFlights";
import ActualFlightTaken from "../home/components/checkFileaClaim/modal/steppers/ActualFlightTaken";
import ExpensesReimbursement from "../home/components/checkFileaClaim/modal/steppers/ExpensesReimbursement";
import UploadRequiredDocument from "../home/components/checkFileaClaim/modal/steppers/UploadRequiredDocument";
import Attorneynotes from "../home/components/checkFileaClaim/modal/steppers/Attorneynotes";
import ConfirmationStatus from "../home/components/checkFileaClaim/modal/steppers/ConfirmationStatus";
import { useForm, FormProvider } from "react-hook-form";
import { CountryDropdown } from "react-country-region-selector";
import axios from "axios";
import moment from "moment";
import base_url from "../../api/bootapi";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import AgreementModal from "./AgreementModal";
import DocuSignModal from "./DocuSignModal";
import PowerModal from "./PowerModal";
import PowerOfAttorney from "./PowerOfAttorney";
import { RemoveCircleOutline } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import SuccessPopUp from "../../components/SuccessPopUp";
import attachmenturl from "../../api/attachmenturl";
import SurewanttoExit from "../../components/SurewanttoExit";
import { current } from "@reduxjs/toolkit";
import RegisterComponent from "../../components/authComponent/RegisterComponent";
import LoginComponent from "../../components/authComponent/LoginComponent";
import { IconPlaneArrival, IconPlaneDeparture } from "@tabler/icons-react";
import { calculateDelay, calculateDelayDuration, dateFormat, fetchInitialFlightData, isValidTime } from "../../components/utils/flightApiUtils";

const FileaClaim = ({ open, close }) => {



  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      personal_details: {

        name_prefix: "",
        first_name: "",
        last_name: "",
        email_id: "",
        contact_no: "",
        passport_number: "",
        address: "",
        unit: '',
        city: '',
        state: '',
        postal_code: '',
        nationality: '',
        date_of_birth: null,
        is_manual: false,
        tickets: '',
        airline_res_no: '',

      },

      claim_id: "",
      type_of_claim: "",
      luggage_delivered: null,
      claim_amount: '',
      exp_reimbursement: "",
      exp_reimbursement_amount: '',
      exp_categories: [],
      exp_other_category: '',

      num_of_passenger: '',
      airline_claim_id: '',
      show_actual_form: false,
      // to_country: '',
      // from_country: '',
      required_actual_flight: null,

      travelers: [],

      original_flight_details: [{
        airline: "",
        flight_number: "",
        airport_of_origin: "",
        airport_of_destination: "",
        date_of_travel: "",
        ticket_ref_no: "",
        hub_code: null,
        original_departure_time: "",
        original_arrival_time: "",
        original_departure_date: "",
        original_arrival_date: "",
        missed_reason: null,
        status_issue: null,
        cancellation_timing: null,
        delay_duration: null,
        flight_class: "Economy",
        additional_details: "",
        is_manual: false,
        search_by: "airline_name",
        triggered: false
      }],

      actual_flight_details: [{
        actual_airline: "",
        actual_hub_code: null,
        actual_flight_number: "",
        actual_airport_of_origin: "",
        actual_airport_of_destination: "",
        actual_date_of_travel: "",
        ticket_ref_no: "",
        actual_departure_time: "",
        actual_arrival_time: "",
        actual_departure_date: "",
        actual_arrival_date: "",
        booking_method: null,
        actual_flight_class: "Economy",
        is_manual: false,
        search_by: "airline_name",
        same_as_original: false,
        triggered: false
      }],
      additional_documents: [],

      additional_claims: [],
      luggage_claim_receipt: null,
      boarding_pass: null,
      passport: null,
      agreement: null,
      power_of_attorney: null,
      airline_response: null,
      baggage_claim: null,
      airline_poa: null,
      additional_exp: null,
      note: '',

      is_terms_watched: false,
      is_agreement_checked: false,
      is_poa_checked: false,
      is_terms_checked: false,

      signUrl: "",
      envelopeId: "",
      agreementUrl: "",
      signers: null,


      deleted: {
        travelers: [],
        original_flights: [],
        actual_flights: [],
        other_claims: [],
        additional_documents: [],
      },


    },
  });

  const {
    handleSubmit,
    control,
    register,
    reset,
    watch,
    setValue,
    getValues,
    trigger,
    formState: { dirtyFields, isDirty, errors },
  } = methods;




  const [defaultAirlines, setDefaultAirlines] = useState([]);
  const [defaultAirports, setDefaultAirports] = useState([]);
  const [temporaryOpened, setTemporaryOpened] = useState(false);
  const [discardModalOpened, { open: openDiscardModal, close: closeDiscardModal }] =
    useDisclosure(false);

  const [draftSavedModalOpened, { open: openDraftSaveModal, close: closeDraftSaveModal }] =
    useDisclosure(false);

  const handleCloseDraftModal = () => {
    closeDraftSaveModal();
    navigate("/drafts");
  }

  const handleCloseDiscardModal = () => {

    closeDiscardModal()
    setTimeout(() => {

      active === 8 && navigate("/dashboard");
    }, 200)
  }

  // 2. Fetch data once for the entire form
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const { initialAirlines, initialAirports } = await fetchInitialFlightData();
        setDefaultAirlines(initialAirlines);

        setDefaultAirports(initialAirports);
      } catch (error) {
        console.error("Failed to load initial flight data:", error);
      } finally {
        // setba(false);
      }
    };

    loadInitialData();
  }, []);






  // In your Parent Form Component
  const [flightModalConfig, setFlightModalConfig] = useState({
    opened: false,
    flights: [],
    modifiedFlightData: [],
    targetPath: null, // e.g., "actual_flight_details.0" or "original_flight_details.1"
  });

  const openFlightModal = (flights, targetPath, modifiedFlightData) => {
    setFlightModalConfig({ opened: true, flights, modifiedFlightData, targetPath });
  };

  const closeFlightModal = () => {
    setFlightModalConfig({ opened: false, flights: [], modifiedFlightData: [], targetPath: null });
  };

  const [selectedFlightIndex, setSelectedFlightIndex] = useState(null);

  const handleSaveFlightDetails = () => {
    const selectedFlight = flightModalConfig.modifiedFlightData[selectedFlightIndex];

    const basePath = flightModalConfig.targetPath; // e.g., "actual_flight_details.0"

    if (selectedFlight && basePath) {

      if (basePath.includes('original')) {
        updateOriginalFlight(selectedFlight, basePath);
      } else {
        updateActualFlight(selectedFlight, basePath);
      }

      closeFlightModal();
    }
  };

  const handleSelectFlight = (index) => {
    setSelectedFlightIndex(index);
  };

  const updateActualFlight = (flight, basePath) => {
    console.log(flight)
    // Extract values to make the code easier to read
    const depActual = flight?.departure?.departureActual;
    const depTz = flight?.departure?.timeZone;

    const arrActual = flight?.arrival?.arrivalActual;
    const arrTz = flight?.arrival?.timeZone;

    // 2. Set the standard text fields (with fallback to empty string)
    setValue(`${basePath}.actual_airport_of_origin`, flight?.departure?.airport || "");
    setValue(`${basePath}.actual_airport_of_destination`, flight?.arrival?.airport || "");
    setValue(`${basePath}.departure_iata_code`, flight?.departure?.iata || "");
    setValue(`${basePath}.arrival_iata_code`, flight?.arrival?.iata || "");

    // Set delay if it exists in your flight object
    if (flight?.delay_cal !== undefined) {
      setValue(`${basePath}.delay_cal`, flight.delay_cal);
    }

    // 3. Conditionally set Departure Date & Time
    if (isValidTime(depActual)) {
      const formattedDep = dateFormat(depActual, depTz);
      setValue(`${basePath}.actual_departure_time`, formattedDep.time);
      setValue(`${basePath}.actual_departure_date`, formattedDep.date);
    } else {
      setValue(`${basePath}.actual_departure_time`, "");
      setValue(`${basePath}.actual_departure_date`, "");
    }

    // 4. Conditionally set Arrival Date & Time
    if (isValidTime(arrActual)) {
      const formattedArr = dateFormat(arrActual, arrTz);
      setValue(`${basePath}.actual_arrival_time`, formattedArr.time);
      setValue(`${basePath}.actual_arrival_date`, formattedArr.date);
    } else {
      setValue(`${basePath}.actual_arrival_time`, "");
      setValue(`${basePath}.actual_arrival_date`, "");
    }
  };

  const updateOriginalFlight = (flight, basePath) => {


    // 2. Extract values from your JSON payload
    const depScheduled = flight?.departure?.departureScheduled;
    const depActual = flight?.departure?.departureActual;
    const depTz = flight?.departure?.timeZone;

    const arrScheduled = flight?.arrival?.arrivalScheduled;
    const arrActual = flight?.arrival?.arrivalActual;
    const arrTz = flight?.arrival?.timeZone;

    // 3. Set standard text fields
    setValue(`${basePath}.airport_of_origin`, flight?.departure?.airport || "");
    setValue(`${basePath}.airport_of_destination`, flight?.arrival?.airport || "");
    setValue(`${basePath}.departure_iata_code`, flight?.departure?.iata || "");
    setValue(`${basePath}.arrival_iata_code`, flight?.arrival?.iata || "");
    setValue(`${basePath}.delay_cal`, flight?.delay_cal || 0);

    // 4. Set Original (Scheduled) Departure Date & Time
    if (isValidTime(depScheduled)) {
      const formattedDepScheduled = dateFormat(depScheduled, depTz);
      setValue(`${basePath}.original_departure_time`, formattedDepScheduled.time);
      setValue(`${basePath}.original_departure_date`, formattedDepScheduled.date);
    } else {
      setValue(`${basePath}.original_departure_time`, "");
      setValue(`${basePath}.original_departure_date`, "");
    }

    // 5. Set Original (Scheduled) Arrival Date & Time
    if (isValidTime(arrScheduled)) {
      const formattedArrScheduled = dateFormat(arrScheduled, arrTz);
      setValue(`${basePath}.original_arrival_time`, formattedArrScheduled.time);
      setValue(`${basePath}.original_arrival_date`, formattedArrScheduled.date);
    } else {
      setValue(`${basePath}.original_arrival_time`, "");
      setValue(`${basePath}.original_arrival_date`, "");
    }

    // 6. Set Actual Departure Date & Time
    if (isValidTime(depActual)) {
      const formattedDepActual = dateFormat(depActual, depTz);
      setValue(`${basePath}.actual_departure_time`, formattedDepActual.time);
      setValue(`${basePath}.actual_departure_date`, formattedDepActual.date);
    } else {
      setValue(`${basePath}.actual_departure_time`, "");
      setValue(`${basePath}.actual_departure_date`, "");
    }

    // 7. Set Actual Arrival Date & Time
    if (isValidTime(arrActual)) {
      const formattedArrActual = dateFormat(arrActual, arrTz);
      setValue(`${basePath}.actual_arrival_time`, formattedArrActual.time);
      setValue(`${basePath}.actual_arrival_date`, formattedArrActual.date);
    } else {
      setValue(`${basePath}.actual_arrival_time`, "");
      setValue(`${basePath}.actual_arrival_date`, "");
    }
  };

  const type_of_claim = watch('type_of_claim');
  const originalFlightDetails = watch('original_flight_details');
  const actualFlightDetails = watch('actual_flight_details');

  const navigate = useNavigate();
  const { claim_id: id } = useParams();


  const fetchDraftData = async () => {
    setbackdropopen(true);

    try {
      const response = await axios.get(
        `${base_url.api1}/users/draft_compensation_request?id=${id}`
      );
      let claimDetails = response.data.compensation_request?.request_data;

      let mainBoardingPass = null;
      if (claimDetails?.boarding_pass) {
        mainBoardingPass = await urlToFile(
          claimDetails.boarding_pass,
          claimDetails.boarding_pass.split("/").pop().split(".")[0] || `boarding_pass`
        );
      }

      let mainBaggageClaim = null;
      if (claimDetails?.baggage_claim) {
        mainBaggageClaim = await urlToFile(
          claimDetails.baggage_claim,
          claimDetails.baggage_claim.split("/").pop().split(".")[0] || `baggage_claim`
        );
      }

      let mainPassport = null;
      if (claimDetails?.passport) {
        mainPassport = await urlToFile(
          claimDetails.passport,
          claimDetails.passport.split("/").pop().split(".")[0] || `passport`
        );
      }

      let mainAgreement = null;
      if (claimDetails?.agreement) {
        mainAgreement = await urlToFile(
          claimDetails.agreement,
          claimDetails.agreement.split("/").pop().split(".")[0] || `agreement`
        );
      }

      let mainPowerOfAttorney = null;
      if (claimDetails?.power_of_attorney) {
        mainPowerOfAttorney = await urlToFile(
          claimDetails.power_of_attorney,
          claimDetails.power_of_attorney.split("/").pop().split(".")[0] || `power_of_attorney`
        );
      }

      // 2. Process Travelers (Sub Claims) & their files
      let formattedTravelers = [];
      if (claimDetails?.sub_claims && claimDetails?.sub_claims.length > 0) {
        formattedTravelers = await Promise.all(
          claimDetails.sub_claims.map(async (claim, index) => {
            const passportFile = await urlToFile(
              claim?.passport || null,
              claim?.passport?.split("/").pop().split(".")[0] || `passport`
            );

            const boardingPassFile = await urlToFile(
              claim?.boarding_pass || null,
              claim?.boarding_pass?.split("/").pop().split(".")[0] || `boarding_pass`
            );

            const additionalDocFile = await urlToFile(
              claim?.additional_doc || null,
              claim?.additional_doc?.split("/").pop().split(".")[0] || `additional_doc`
            );

            return {
              ...claim,
              name_prefix: claim?.name_prefix || "",
              date_of_birth: formatToMMDDYYYY(claim.date_of_birth),
              passport: passportFile,
              boarding_pass: boardingPassFile,
              additional_doc: additionalDocFile,
              // Keeping these for your custom UI file name displays if needed
              passport_name: passportFile ? `passport_${index + 1}` : null,
              passport_file_name: passportFile?.name || null,
              boardingpass_name: boardingPassFile ? `boarding_pass_${index + 1}` : null,
              boarding_pass_file_name: boardingPassFile?.name || null,
            };
          })
        );
      }

      // 3. Process Original Flight Details mapping (reversing the save mapping)

      // 5. Construct the Reset Data Object matching react-hook-form schema
      const resetData = {
        // Keep existing default structure for arrays if they are empty
        ...methods.getValues(),

        personal_details: {
          name_prefix: claimDetails.name_prefix || "",
          first_name: claimDetails.first_name || "",
          last_name: claimDetails.last_name || "",
          email_id: claimDetails.email_id || "",
          contact_no: claimDetails.contact_no || "",
          passport_number: claimDetails.passport_number || "",
          address: claimDetails.address || "",
          unit: claimDetails.unit || "",
          city: claimDetails.city || "",
          state: claimDetails.state || "",
          postal_code: claimDetails.postal_code || "",
          nationality: claimDetails.nationality || "",
          date_of_birth: formatToMMDDYYYY(claimDetails.date_of_birth) || null,
          tickets: claimDetails.tickets || "",
          airline_res_no: claimDetails.airline_res_no || "",
          is_manual: false, // fallback boolean
        },

        claim_id: claimDetails.contact_no || "", // You were setting this in setclaimid
        type_of_claim: claimDetails.type_of_claim || "",
        claim_amount: claimDetails.claim_amount || "",
        exp_reimbursement: claimDetails.exp_reimbursement || (claimDetails.exp_reimbursement_amount ? "yes" : "no"),
        exp_reimbursement_amount: claimDetails.exp_reimbursement_amount || "",
        exp_categories: claimDetails.exp_categories || [],
        exp_other_category: claimDetails.exp_other_category || '',
        num_of_passenger: claimDetails.num_of_passenger || "",
        luggage_delivered: formatToMMDDYYYY(claimDetails.luggage_delivered) || null,
        required_actual_flight: claimDetails.flightProvider,
        // to_country: claimDetails.to_country,
        // from_country: claimDetails.from_country,
        travelers: formattedTravelers,
        original_flight_details: (claimDetails.flight_details && claimDetails.flight_details.length > 0)
          ? claimDetails.flight_details.map((flight) => ({
            ...flight,
            cancellation_timing:
              flight.cancellation_timing ||
              (flight.cancellation_info_before_7_days
                ? "cancellation_info_before_7_days"
                : flight.cancellation_info_before_14_days
                  ? "cancellation_info_before_14_days"
                  : flight.cancellation_info_before
                    ? "cancellation_info_before_7_days"
                    : flight.cancellation_info_at_airport
                      ? "cancellation_info_before_14_days"
                      : flight.cancellation_info_after_7_days
                        ? "cancellation_info_after_7_days"
                        : flight.cancellation_info_at_airport
                          ? "cancellation_info_at_airport"
                          : null),
          }))
          : methods.getValues("original_flight_details"),
        actual_flight_details: claimDetails.actual_flight_details.length > 0 ? claimDetails.actual_flight_details : methods.getValues("actual_flight_details"),

        baggage_claim: mainBaggageClaim,
        boarding_pass: mainBoardingPass,
        passport: mainPassport,
        power_of_attorney: mainPowerOfAttorney,
        agreement: mainAgreement,

        is_agreement_checked: claimDetails.is_agreement_checked || false,
        is_poa_checked: claimDetails.is_poa_checked || false,
        is_terms_watched: claimDetails.is_terms_watched || false,
        is_terms_checked: claimDetails.is_terms_checked || false,
        signers: claimDetails.signers || null,
        additional_documents: claimDetails.other_doc ? [claimDetails.other_doc] : [], // Adapt based on how you handle arrays vs single strings
        note: claimDetails.note || "",
      };

      // 6. Reset the form with the fetched data
      methods.reset(resetData);

      setActive(claimDetails.activeStep || 1);


    } catch (error) {
      if (error?.response?.data?.status_code === 400) {
        navigate("/claimstatus");
      }
    } finally {
      setbackdropopen(false);
    }
  };

  useEffect(() => {
    if (id) {

      fetchDraftData();
    }
  }, [id]);



  const [backdropopen, setbackdropopen] = useState(false);

  const [eligibleForClaim, setEligibleForClaim] = useState(false);
  const [contactNumber, setContactNumber] = useState('');





  const formatToYYYYMMDD = (dateOfBirth) => {


    return moment(dateOfBirth, "MM-DD-YYYY").format("YYYY-MM-DD");
  };

  const formatToMMDDYYYY = (dateString) => {
    if (!dateString) return "";
    return moment(dateString).format("MM-DD-YYYY");

  };



  const addCustomerNote = (customerNote, notes) => {
    const trimmedNote = customerNote?.trim();

    // Don't add the note if it's empty, null, or only contains spaces
    if (!trimmedNote) {
      return notes ? notes : null;
    }

    const dateTime = moment().format("h:mm A MMMM D, YYYY");
    const newNote = {
      user: "customer",
      note: trimmedNote,
      timestamp: dateTime,
    };

    return notes ? [newNote, ...notes] : [newNote];
  };

  const isFlightProvided = watch('required_actual_flight');


  // const [totalDelay, setTotalDelay] = useState(null);
  // const [totalDelayTime, setTotalDelayTime] = useState(null);

  // useEffect(() => {
  //   const { totalDelayTime, totalDelay } = getFlightDelayDetails(
  //     originalFlightDetails,
  //     actualFlightDetails,
  //     isFlightProvided
  //   );

  //   console.log(totalDelay, totalDelayTime)

  //   setTotalDelayTime(totalDelayTime);
  //   setTotalDelay(totalDelay);
  // }, [originalFlightDetails, actualFlightDetails, isFlightProvided]);


  const getFlightDelayDetails = (
    originalFlightDetails,
    actualFlightDetails,
    isFlightProvided
  ) => {
    try {
      const lastFlight = originalFlightDetails?.at(-1);
      const lastActualFlight =
        isFlightProvided === "no"
          ? originalFlightDetails?.at(-1)
          : actualFlightDetails?.at(-1);

      if (
        !lastFlight?.original_arrival_date ||
        !lastFlight?.original_arrival_time ||
        !lastActualFlight?.actual_arrival_date ||
        !lastActualFlight?.actual_arrival_time
      ) {
        return {
          totalDelayTime: null,
          totalDelay: null,
        };
      }

      const originalArrivalDateTime = `${formatToYYYYMMDD(
        lastFlight.original_arrival_date
      )}T${lastFlight.original_arrival_time}`;

      const actualArrivalDateTime = `${formatToYYYYMMDD(
        lastActualFlight.actual_arrival_date
      )}T${lastActualFlight.actual_arrival_time}`;

      return {
        totalDelayTime: calculateDelay(
          actualArrivalDateTime,
          originalArrivalDateTime
        ),
        totalDelay: calculateDelayDuration(
          originalArrivalDateTime,
          actualArrivalDateTime
        ),
      };
    } catch (error) {
      console.error("Failed to calculate delays:", error);

      return {
        totalDelayTime: null,
        totalDelay: null,
      };
    }
  };


  const getFlightDetailsFromOriginal = () => {

    let formattedActualFlightDetails;
    if (isFlightProvided === "yes") {

      formattedActualFlightDetails = actualFlightDetails.map((flight, index) => {
        const flightData = {
          actual_departure: `${formatToYYYYMMDD(flight.actual_date_of_travel)}T${flight.actual_departure_time?.trim()
            ? flight.actual_departure_time
            : "00:00"
            }`,

          actual_arrival: `${formatToYYYYMMDD(flight.actual_arrival_date)}T${flight.actual_arrival_time?.trim()
            ? flight.actual_arrival_time
            : "00:00"
            }`,
          actual_airport_of_origin: flight.actual_airport_of_origin,
          actual_date_of_travel: formatToYYYYMMDD(flight.actual_date_of_travel),
          actual_airport_of_destination: flight.actual_airport_of_destination,
          actual_airline: flight.actual_airline,
          actual_flight_number: flight.actual_flight_number,
          provided_by_airline: flight.booking_method === 'airline',
          self_booked: flight.booking_method === 'self_booked',
          ticket_ref_no: flight.ticket_ref_no,
          airline_code: flight?.actual_hub_code,
          actual_flight_class: flight.actual_flight_class,
          sequence: index + 1
        };

        return flightData;
      });
    } else if (isFlightProvided === "no") {



      formattedActualFlightDetails = originalFlightDetails.map((flight, index) => {
        const flightData = {
          actual_departure: `${formatToYYYYMMDD(flight.actual_departure_date)}T${flight.actual_departure_time?.trim()
            ? flight.actual_departure_time
            : "00:00"
            }`,

          actual_arrival: `${formatToYYYYMMDD(flight.actual_arrival_date)}T${flight.actual_arrival_time?.trim()
            ? flight.actual_arrival_time
            : "00:00"
            }`,
          actual_airport_of_origin: flight.airport_of_origin,
          actual_date_of_travel: formatToYYYYMMDD(flight.actual_departure_date),
          actual_airport_of_destination: flight.airport_of_destination,
          actual_airline: flight.airline,
          actual_flight_number: flight.flight_number,
          provided_by_airline: null,
          self_booked: true,
          ticket_ref_no: null,
          airline_code: flight?.hub_code,

          actual_flight_class: flight.flight_class,
          sequence: index + 1

        };


        return flightData;
      });





    } else {
      formattedActualFlightDetails = []
    }




    console.log("Actual flight Details from Original", formattedActualFlightDetails)
    return formattedActualFlightDetails




  }



  const onSubmit = async (data) => {







    setbackdropopen(true);






    const { personal_details, note, travelers, original_flight_details, actual_flight_details, type_of_claim } = data;




    const formData = new FormData();

    const originalFlighDetailsData = original_flight_details.map((flight, index) => {

      const newData = {
        airline: flight.airline,
        flight_number: flight.flight_number,
        airport_of_origin: flight.airport_of_origin,
        airport_of_destination: flight.airport_of_destination,
        scheduled_arrival: `${formatToYYYYMMDD(flight.original_arrival_date)}T${flight.original_arrival_time}`,
        scheduled_departure: `${formatToYYYYMMDD(flight.date_of_travel)}T${flight.original_departure_time}`,
        date_of_travel: formatToYYYYMMDD(flight.date_of_travel),
        delayed: flight.status_issue === 'delayed',
        cancelled: flight.status_issue === 'cancelled',
        missed: flight.status_issue === 'missed',
        denied: flight.status_issue === 'denied',
        downgraded: flight.status_issue === 'downgraded',
        delay_cal: flight?.delay_cal || 0,
        missed_due_to_error: flight.missed_reason === 'airline_error',
        missed_due_to_personal: flight.missed_reason === 'personal_error',
        cancellation_info_before_7_days: flight.cancellation_timing === 'cancellation_info_before_7_days',
        cancellation_info_before_14_days: flight.cancellation_timing === 'cancellation_info_before_14_days',
        cancellation_info_after_7_days: flight.cancellation_timing === 'cancellation_info_after_7_days',
        cancellation_info_at_airport: flight.cancellation_timing === 'cancellation_info_at_airport',
        delay_duration: flight.status_issue === 'delayed' ? flight.delay_duration : null,
        ticket_ref_no: flight.ticket_ref_no,
        flight_class: flight.flight_class,
        additional_details: flight.additional_details,
        airline_code: flight?.hub_code,
        sequence: index + 1
      };

      return newData;
    });



    const travelersData = travelers.map((traveler, index) => {
      const travelerData = {
        name_prefix: traveler.name_prefix,
        first_name: traveler.first_name,
        last_name: traveler.last_name,
        passport_number: traveler.passport_number,
        tickets: traveler.tickets,
        date_of_birth: formatToYYYYMMDD(traveler.date_of_birth),
        airline_res_no: traveler.airline_res_no,
        country: traveler.country,


      };

      if (traveler.passport === null) {
        travelerData.passport = null
      }

      if (traveler.boarding_pass === null) {
        travelerData.boarding_pass = null
      }

      if (traveler.additional_doc === null) {
        travelerData.additional_doc = null
      }

      if (traveler.id !== null) {
        travelerData.id = traveler.id;
      }
      if (traveler.passport instanceof File) {
        travelerData.passport = `passport_${index}`;

        formData.append(`passport_${index}`, traveler.passport);
      }

      if (traveler.boarding_pass instanceof File) {
        travelerData.boarding_pass = `boarding_pass_${index}`;
        formData.append(`boarding_pass_${index}`, traveler.boarding_pass);
      }

      if (traveler.additional_doc instanceof File) {
        travelerData.additional_doc = `additonal_doc_${index}`;
        formData.append(`additonal_doc_${index}`, traveler.additional_doc);
      }

      return travelerData;
    });


    const updatedNotes = addCustomerNote(note, "");

    const { totalDelayTime, totalDelay } = getFlightDelayDetails(originalFlightDetails, actualFlightDetails, isFlightProvided);

    console.log(totalDelay, totalDelayTime);




    const formObject = {
      name_prefix: personal_details.name_prefix,

      first_name: personal_details.first_name,
      last_name: personal_details.last_name,
      address: personal_details.address?.label || personal_details.address,
      passport_number: personal_details.passport_number,
      unit: personal_details.unit,
      nationality: personal_details.nationality,
      date_of_birth: formatToYYYYMMDD(personal_details.date_of_birth),
      state: personal_details.state,
      city: personal_details.city,
      postal_code: personal_details.postal_code,
      num_of_passenger: data.num_of_passenger,
      contact_no: personal_details.contact_no,
      email_id: personal_details.email_id,
      receive_any_compensation: personal_details.receive_any_compensation,
      date_of_travel: data.date_of_travel,
      tickets: personal_details.tickets,
      sub_claims: travelersData,
      other_claims: [],
      flight_details: type_of_claim !== "lost/damaged" && type_of_claim !== "lost_wages" ? originalFlighDetailsData : [],
      actual_flight_details: isFlightProvided ? getFlightDetailsFromOriginal() : [],
      note: updatedNotes,
      type_of_claim: type_of_claim,
      previous_type_of_claim: type_of_claim,
      delay: (type_of_claim !== "cancelled" && type_of_claim !== "denied_boarding" && type_of_claim !== "other" && type_of_claim !== "lost/damaged" && type_of_claim !== "lost_wages") ? totalDelayTime : null,
      airline_res_no: personal_details.airline_res_no,
      delay_duration_minutes: totalDelay,
      signers: data.signers || [],
      status: "incomplete",
      claim_amount: data.claim_amount,
      exp_reimbursement_amount: data.exp_reimbursement === 'yes' ? Number(data.exp_reimbursement_amount || 0).toFixed(2) : null,
      exp_reimbursement: data.exp_reimbursement === 'yes' ? true : false,
      exp_categories: data.exp_reimbursement === 'yes' ? data.exp_categories : [],
      airline_claim_id: data.airline_claim_id,
      luggage_delivered: type_of_claim === "lost/damaged" ? moment(data.luggage_delivered).format("YYYY-MM-DD") : null,
      unique_claim_id: data.claim_id,
      // travel_from_cuntry: data.from_country,
      // travel_to_cuntry: data.to_country,
      envelope_id: data.envelopeId,
      agreement_signed: true,
      agreement_url: data.agreementUrl,
      source_of_claim: "flyandclaim",




    };

    if (data.exp_categories?.includes("Other") && data.exp_reimbursement === 'yes') {
      formObject.exp_categories = [
        ...data.exp_categories,
        data.exp_other_category,
      ];
    }



    if (data?.signers && data?.signers?.length > 0) {

      const allSigned = (data.signers || []).every(
        recipient => recipient.signed === true
      );

      if (!allSigned) {
        formObject.status = 'POA Draft'

      }

    }




    const handleFileField = (value, key) => {
      if (value instanceof File) {
        formData.append(key, value);
      } else if (!value) {
        formObject[key] = null;
      }
      // Existing URL/string -> do nothing
    };

    handleFileField(data.passport, "passport");
    handleFileField(data.boarding_pass, "boarding_pass");
    handleFileField(data.agreement, "agreement");
    handleFileField(data.airline_response, "airline_response");
    handleFileField(data.baggage_claim, "baggage_claim");
    handleFileField(data.airline_poa, "airline_poa");
    handleFileField(data.power_of_attorney, "power_of_attorney");


    // if (data.agreement) {
    //   const pdfFile = new File([data.agreement], "agreement.pdf", {
    //     type: "application/pdf", lastModified: Date.now()
    //   });


    //   formData.append("agreement", pdfFile);
    // }
    // if (data.power_of_attorney instanceof Blob) {
    //   const file = new File(
    //     [data.power_of_attorney],
    //     "power_of_attorney.pdf",
    //     { type: "application/pdf", lastModified: Date.now() }
    //   );

    //   formData.append("power_of_attorney", file);
    // }


    const jsonFormObject = JSON.stringify(formObject);


    formData.append("data", jsonFormObject);

    const otherDocs = Array.isArray(data.additional_documents)
      ? data.additional_documents
      : data.additional_documents
        ? [data.additional_documents]
        : Array.isArray(data.other_docs)
          ? data.other_docs
          : data.other_docs
            ? [data.other_docs]
            : [];

    otherDocs.forEach((doc) => {
      if (doc instanceof File) {
        formData.append("document", doc);
      }
    });

    console.log("FormData======>", formObject)

    // return

    saveCompensation(formData)













  }

  const validateValue = (value) => {
    if (value === "" || value === null || value === undefined) {
      return true;
    }
    return false;
  };

  const handleUploadFile = async (file) => {


    try {
      const formData = new FormData();

      // const requestData = {
      //   user_id: user?.id,
      //   };

      const requestData = {
        user_id: null,
      };

      const jsonFormObject = JSON.stringify(requestData);
      formData.append("data", jsonFormObject);

      formData.append('image', file || null);

      const response = await axios.post(
        `${base_url.api1}/users/draft_file`,
        formData,
        {
          headers: {
            Origin: "https://flyandclaim.odisoft.in",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(response?.data?.data[0].file);
      return response?.data?.data[0].file;
    } catch (error) {
      console.log(error.message);


    }




  };

  const uploadIfExists = async (file) => {
    if (file) {
      return await handleUploadFile(file);
    }
    return null;
  };

  const handleDraftSave = async () => {
    setTemporaryOpened(false);
    setbackdropopen(true);

    // 1. Get all current values from react-hook-form
    const formValues = methods.getValues();
    const {
      personal_details,
      travelers,
      original_flight_details,
      actual_flight_details,
      type_of_claim,
      luggage_delivered,
      // from_country,
      // to_country,
      claim_amount,
      exp_reimbursement,
      exp_reimbursement_amount,
      exp_categories,
      exp_other_category,
      additional_documents,
      num_of_passenger,
      envelopeId,
      note,
      boarding_pass,
      passport,
      baggage_claim,
      required_actual_flight,
      agreement,
      power_of_attorney,
      signers,
      agreementUrl,
      is_agreement_checked,
      is_terms_checked,
      is_poa_checked,
      is_terms_watched
    } = formValues;

    console.log(original_flight_details, actual_flight_details);



    try {
      // 2. Process Travelers (Family Members) and upload their files
      const familyMembersData = await Promise.all(
        travelers.map(async (member) => {
          const memberData = {
            name_prefix: validateValue(member?.name_prefix) ? null : member?.name_prefix,
            first_name: validateValue(member?.first_name?.trim()) ? null : member?.first_name?.trim(),
            last_name: validateValue(member?.last_name) ? null : member?.last_name,
            date_of_birth: validateValue(formatToYYYYMMDD(member?.date_of_birth)) ? null : formatToYYYYMMDD(member?.date_of_birth),
            passport_number: validateValue(member?.passport_number) ? null : member?.passport_number,
            tickets: validateValue(member?.tickets) ? null : member?.tickets,
            country: validateValue(member?.country) ? null : member?.country,
            airline_res_no: validateValue(member?.airline_res_no) ? null : member?.airline_res_no,
          };

          const passportFile = await uploadIfExists(member?.passport);
          if (passportFile) memberData.passport = passportFile;

          const additionalDocFile = await uploadIfExists(member?.additional_doc);
          if (additionalDocFile) memberData.additional_doc = additionalDocFile;

          const boardingPassFile = await uploadIfExists(member?.boarding_pass);
          if (boardingPassFile) memberData.boarding_pass = boardingPassFile;

          if (member?.id !== null) {
            memberData.id = member.id;
          }

          return memberData;
        })
      );



      // 5. Construct Final Save Object
      let saveFormObject = {
        name_prefix: validateValue(personal_details.name_prefix) ? null : personal_details.name_prefix,
        first_name: validateValue(personal_details.first_name) ? null : personal_details.first_name,
        last_name: validateValue(personal_details.last_name) ? null : personal_details.last_name,
        address: validateValue(personal_details.address) ? null : personal_details.address,
        passport_number: validateValue(personal_details.passport_number) ? null : personal_details.passport_number,
        unit: validateValue(personal_details.unit) ? null : personal_details.unit,
        nationality: validateValue(personal_details.nationality) ? null : personal_details.nationality,
        date_of_birth: validateValue(personal_details.date_of_birth) ? null : formatToYYYYMMDD(personal_details.date_of_birth),
        airline_res_no: validateValue(personal_details.airline_res_no) ? null : personal_details.airline_res_no,
        contact_no: validateValue(personal_details.contact_no) ? null : personal_details.contact_no,
        email_id: validateValue(personal_details.email_id) ? null : personal_details.email_id,
        tickets: validateValue(personal_details.tickets) ? null : personal_details.tickets,
        postal_code: validateValue(personal_details.postal_code) ? null : personal_details.postal_code,
        state: validateValue(personal_details.state) ? null : personal_details.state,
        city: validateValue(personal_details.city) ? null : personal_details.city,

        flight_details: original_flight_details,
        actual_flight_details: actual_flight_details,
        sub_claims: familyMembersData.length === 0 ? [] : familyMembersData,
        other_claims: null, // As per original code

        note: validateValue(note) ? null : note,
        envelope_id: envelopeId,
        type_of_claim: validateValue(type_of_claim) ? null : type_of_claim,
        num_of_passenger: validateValue(num_of_passenger) ? null : num_of_passenger,
        user_id: null,
        claim_amount: validateValue(claim_amount) ? null : claim_amount,
        exp_reimbursement_amount: validateValue(exp_reimbursement_amount) ? null : exp_reimbursement_amount,
        exp_other_category: validateValue(exp_other_category) ? null : exp_other_category,

        exp_categories: exp_categories,
        exp_reimbursement: validateValue(exp_reimbursement) ? "no" : exp_reimbursement,
        luggage_delivered: validateValue(luggage_delivered) ? null : formatToYYYYMMDD(luggage_delivered),
        // from_country: validateValue(from_country) ? null : from_country,
        // to_country: validateValue(to_country) ? null : to_country,
        signers: signers || [],
        delay_duration_minutes: null, // Assuming this relies on state/functions outside the form or adapt as needed
        flightProvider: required_actual_flight, // Adapt if this moved inside formValues
        activeStep: active, // Adapt if this moved inside formValues
        agreement_url: agreementUrl,

        is_agreement_checked: is_agreement_checked || false,
        is_poa_checked: is_poa_checked || false,
        is_terms_checked: is_terms_checked || false,
        is_terms_watched: is_terms_watched || false,
      };

      // 6. Upload Main Documents
      const boardingPassMain = await uploadIfExists(boarding_pass);
      if (boardingPassMain) saveFormObject.boarding_pass = boardingPassMain;

      const passportMain = await uploadIfExists(passport);
      if (passportMain) saveFormObject.passport = passportMain;

      const agreementMain = await uploadIfExists(agreement);
      if (agreementMain) saveFormObject.agreement = agreementMain;

      const powerOfAttorneyMain = await uploadIfExists(power_of_attorney);
      if (powerOfAttorneyMain) saveFormObject.power_of_attorney = powerOfAttorneyMain;


      const baggageMain = await uploadIfExists(baggage_claim);
      if (baggageMain) saveFormObject.baggage_claim = baggageMain;

      if (Array.isArray(additional_documents) && additional_documents.length > 0) {
        const otherDocMain = await uploadIfExists(additional_documents[0]);
        if (otherDocMain) saveFormObject.other_doc = otherDocMain;
      }



      // console.log("Payload to save:", saveFormObject);

      // 7. API Call
      const requestPayload = {
        request_data: saveFormObject,
        status: "draft"
      };

      const endpoint = id
        ? `${base_url.api1}/users/draft_compensation_request?id=${id}`
        : `${base_url.api1}/users/draft_compensation_request`;

      const apiMethod = id ? axios.put : axios.post;

      const response = await apiMethod(endpoint, requestPayload, {
        headers: {
          Origin: "https://flyandclaim.odisoft.in",
        },
      });


      openDraftSaveModal()

    } catch (error) {
      console.error("Error saving form data by save click", error);
    } finally {
      setbackdropopen(false);
    }
  };





  const deleteDraft = async () => {

    if (!id) return null
    const response = await axios.delete(
      `${base_url.api1}/users/draft_compensation_request?id=${id}`
    );

    console.log("Delete Response", response.data);
    return response;
  };
  const saveCompensation = async (formData) => {
    try {
      setbackdropopen(true);

      const response = await axios.post(
        `${base_url.api1}/tourapp/compensation_request`,
        formData,
        {
          headers: {
            Origin: "https://flyandclaim.odisoft.in",
          },
        }
      );

      // Compensation request succeeded.
      // Try deleting the draft, but don't fail the whole flow if it errors.
      if (id) {
        try {
          await deleteDraft();
        } catch (err) {
          console.error("Failed to delete draft:", err);
        }
      }

      setEligibleForClaim(true);
      setContactNumber(response?.data?.data?.contact_no);
      setActive(8);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "There was a problem connecting to the server. Please try again later.",
      });

      setEligibleForClaim(false);
    } finally {
      setbackdropopen(false);
    }
  };

  const [active, setActive] = useState(1);



  useEffect(() => {
    const handleBack = () => {

      if (type_of_claim === "cancelled" && active === 5) {
        setActive((current) => current - 2);
        // window.history.pushState(null, "", window.location.href);
        return;
      }

      if ((type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") && active === 4) {
        setActive((current) => current - 2);
        // window.history.pushState(null, "", window.location.href);
        return;
      }

      if (active > 1) {
        setActive((current) => current - 1);
        // window.history.pushState(null, "", window.location.href);
        return;
      }

      // active === 1 → leave page
      navigate(-1);
    };

    window.addEventListener("popstate", handleBack);
    return () => window.removeEventListener("popstate", handleBack);
  }, [active]);






  async function urlToFile(url, fileBaseName) {
    if (!url) return null;            // No URL -> no file
    url = attachmenturl + url
    try {
      const response = await fetch(url);
      if (!response.ok) return null;  // Invalid URL -> skip

      const blob = await response.blob();

      const ext = blob.type.split("/")[1] || "bin";
      const fileName = `${fileBaseName}.${ext}`;

      return new File([blob], fileName, { type: blob.type });
    } catch (e) {
      console.warn("Failed to convert URL to file:", url, e);
      return null;
    }
  }



  const isMobile = useMediaQuery("(max-width: 768px)");




  function getFlightStatus(code) {
    switch (code) {
      case "A":
        return "Active (in flight)";
      case "C":
        return "Canceled";
      case "D":
        return "Diverted";
      case "DN":
        return "Data Needed / Not Available";
      case "L":
        return "Landed";
      case "NO":
        return "Not Operational";
      case "R":
        return "Redirected";
      case "S":
        return "Scheduled";
      case "U":
        return "Unknown";
      default:
        return code;
    }
  }

  const fmt = (dt) => {
    if (!dt) return "N/A"; // null, undefined, empty, 0

    const date = new Date(dt);
    if (isNaN(date.getTime())) return "N/A"; // invalid date

    return date.toLocaleString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };


  const handleBack = () => {

    if (eligibleForClaim || active === 8) return


    if (type_of_claim === "cancelled" && active === 5) {
      setActive((current) => current - 2);
      // window.history.pushState(null, "", window.location.href);
      return;
    }

    if ((type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") && active === 4) {
      setActive((current) => current - 2);
      // window.history.pushState(null, "", window.location.href);
      return;
    }

    if (active > 1) {
      setActive((current) => current - 1);
      // window.history.pushState(null, "", window.location.href);
      return;
    }


  };


  const handleSave = () => {
    active === 8 ? handleClaimClose() : openDiscardModal()
  }

  const handleClaimClose = () => {


    setTimeout(() => {

      active === 8 && navigate("/dashboard");
    }, 200)
  };



  return (
    <div className="modal-wrapper">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>


















      <div>
        <div className="modal-toolbar">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Back
                // onClick={() => {
                onClick={handleBack}
                // if (active > 1) {
                //   setActive((current) => current - 1);
                // }
                // }}
                style={{ cursor: "pointer" }}
              />
              <span className="stepper-count">Step {active}/8</span>
            </div>
            <Link to={"/"}>
              <Logo />
            </Link>

            <div className="stepper-save-btn">


              <Close onClick={handleSave} />
            </div>
            <div className="mobile-close-btn">
              <Close onClick={handleSave} />
            </div>
          </div>
          <div style={{ marginTop: "20px" }} className="stepper-progress-bar">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#314064",
                  fontWeight: 500,
                }}
              >
                {active === 1
                  ? "Traveler information"
                  : active === 2
                    ? "Claim details"
                    : active === 3
                      ? "Originally booked flights"
                      : active === 4
                        ? (type_of_claim !== "lost/damaged" && type_of_claim !== "lost_wages" ? "Actual flights taken" : "Flight details")
                        : active === 5
                          ? "Claim for expenses reimbursement"
                          : active === 6
                            ? "Upload required documents"
                            : active === 7
                              ? "Attorney notes"
                              : active === 8
                                ? "Submission results"
                                : "Fly claim"}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#314064",
                  fontWeight: 700,
                }}
              >
                Step {active}/8
              </span>
            </div>
            <div
              style={{
                height: "4px",
                borderRadius: "2px",
                overflow: "hidden",
                backgroundColor: "#E6F6FF",
              }}
            >
              <div
                style={{
                  width: `${(active / 8) * 100}%`,
                  height: "4px",
                  borderRadius: "2px",
                  backgroundColor: "#314064",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="modal-main-wrapper">
            <div className="modal-main-left">
              <h4>Your claim progress</h4>
              <div>
                <Stepper
                  active={(type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") && active > 3 ? active - 1 : active}
                  // onStepClick={(step) => {
                  //   // Only allow going to completed steps (steps before current active)

                  //   // handleNext()
                  //   if (getformData?.claimDetails?.type_of_claim === "cancelled" && step === 3) {
                  //     return
                  //   }

                  //   if (getformData?.claimDetails?.type_of_claim === "lost/damaged" && step === 2) {
                  //     return
                  //   }
                  //   if (step < completedStep) {
                  //     setActive(step + 1);
                  //   }
                  // }}
                  allowStepSelect={false}
                  icon={false}
                  orientation="vertical"
                  mt={"xl"}
                  completedIcon={<CheckIcon />}
                  styles={{
                    stepCompletedIcon: {
                      background: "#314064",
                      borderRadius: "50%",
                    },
                    stepLabel: {
                      paddingTop: "15px",
                      color: "#7B8287",
                      cursor: (step) => (step < active - 1 ? "pointer" : "default"),
                    },
                    stepDescription: {
                      display: "none",
                    },
                    stepIcon: {
                      background: "#E6F6FF",
                      border: 0,
                    },
                    separator: {
                      borderColor: "#314064",
                    },
                  }}
                >
                  <Stepper.Step label="Traveler information" />
                  <Stepper.Step label="Claim details" />
                  {
                    type_of_claim !== "lost/damaged" && type_of_claim !== "lost_wages" && <Stepper.Step label="Originally booked flights" />
                  }

                  <Stepper.Step hidden={type_of_claim === "cancelled"} label={type_of_claim !== "lost/damaged" && type_of_claim !== "lost_wages" ? "Actual flights taken" : "Flight details"} />

                  <Stepper.Step label="Claim for expenses reimbursement" />

                  <Stepper.Step label="Upload required documents" />
                  <Stepper.Step label="Attorney notes" />
                  <Stepper.Step label="Submission results" />
                </Stepper>
              </div>
            </div>

            <div className="modal-main-right">
              {active === 1 && (
                <TravelerInformation
                  setActive={setActive}
                />
              )}
              {active === 2 && (
                <ClaimDetails
                  setActive={setActive}
                  setTemporaryOpened={setTemporaryOpened}
                />
              )}
              {active === 3 && (
                <OriginallyBookedFlights
                  setActive={setActive}
                  setLoading={setbackdropopen}
                  defaultAirlines={defaultAirlines}
                  defaultAirports={defaultAirports} openFlightModal={openFlightModal}
                  setTemporaryOpened={setTemporaryOpened}
                />
              )}
              {active === 4 && (
                <ActualFlightTaken
                  setActive={setActive}
                  setLoading={setbackdropopen}
                  defaultAirlines={defaultAirlines}
                  defaultAirports={defaultAirports} openFlightModal={openFlightModal}
                  setTemporaryOpened={setTemporaryOpened}
                />
              )}
              {active === 5 && (
                <ExpensesReimbursement
                  setActive={setActive}
                  setTemporaryOpened={setTemporaryOpened}
                />
              )}
              {active === 6 && (
                <UploadRequiredDocument
                  setActive={setActive}
                  setTemporaryOpened={setTemporaryOpened}
                />
              )}

              {active === 7 && (
                <Attorneynotes
                  setLoading={setbackdropopen}
                  setActive={setActive}
                  setTemporaryOpened={setTemporaryOpened}
                />
              )}
              {active === 8 && (
                <ConfirmationStatus
                  eligibleForClaim={eligibleForClaim}
                  contactNumber={contactNumber}

                />
              )}

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>

                {active < 7 &&
                  <p style={{ fontSize: "15px", marginBootom: "0 !important" }}><span style={{ color: "#de8385" }}>*</span> Please fill all required fields</p>

                }
              </div>
            </div>


          </div>

        </form>

      </FormProvider>




      <Modal
        opened={temporaryOpened}
        onClose={() => setTemporaryOpened(false)}

        centered
        radius="md"
        size="md"
        padding={0}
        styles={{
          header: {
            padding: "0px 15px"
          }
        }}
        closeOnClickOutside={false}
      >

        <div className="instruct-modal-wrapper
        
        ">

          <h2>
            Before saving the page
          </h2>

          <ul>
            {/* <li>You need to create an account.</li> */}
            <li>Your claim will be saved temporarily for <b>7 days</b>.</li>
            <li>After 7 days, the temporary claim will be deleted automatically.</li>
            <li>You will receive an email with a link to access and continue your temporary claim.</li>



          </ul>

          {/* <p style={{textAlign:"center",color:"#ff4b4bff",borderColor:"#ff4b4bff",background:"rgb(255 170 170 / 5%)",borderRadius:"6px"}}>Please register or sign in to securely save and continue later.</p> */}

          <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>

            <CustomButton btnText={'Continue'} onClick={handleDraftSave} style={{ width: "200px" }} />
          </div>
        </div>





      </Modal>



      <SurewanttoExit
        opened={discardModalOpened}
        handleSaveClick={() => {

          navigate("/start-your-claim");
        }}
        messageText="Are you sure!"
        messagePara="Do you want to discard the claim ?"
        open2={openDraftSaveModal}
        isNew={true}
        close={handleCloseDiscardModal}
        active={active}
        btnCancelText="No"
        btnSavetext="Yes"
      />

      <Modal
        opened={draftSavedModalOpened}
        onClose={handleCloseDraftModal}
        centered
        radius={"xl"}
        size={"lg"}
        withCloseButton={false}
      >
        <div className="universal-modal-wrapper">
          <CircleTickIcon />
          <h1
            className="header"
            style={{ color: "#314064", textAlign: "center", fontSize: "40px", lineHeight: "55px" }}
          >Claim saved successfully for 7 days!

          </h1>
          <p
            style={{ textAlign: "center", color: "#222222" }}
            className="sub-header"
          >
            To complete the claim, please access your saved claim on our website <a href='https://flyandclaim.com'>www.flyandclaim.com</a>
          </p>
          <CustomButton
            style={{ width: "50%" }}
            btnText={"BACK"}
            flex={1}
            onClick={handleCloseDraftModal}
          />
        </div>
      </Modal>



      <Modal
        opened={flightModalConfig.opened}
        closeOnClickOutside={false}
        onClose={() => {
          // Reset everything on close
          setFlightModalConfig({ opened: false, flights: [], modifiedFlightData: [], targetPath: null });
          setSelectedFlightIndex(null);
        }}
        centered

        size={"1000px"}
        withCloseButton={true}

      >

        <div style={{ padding: "20px" }}>

          <h2 style={{ fontSize: "20px", fontWeight: 'bold' }}>
            Select Your Flight Details
          </h2>

          {
            flightModalConfig.flights?.map((flight, index) => {

              const isActive = index === selectedFlightIndex;
              const operationalTimes = flight?.operationalTimes || {};
              const status = flight?.status || "";


              return (<article className="flight-card" key={index} style={{ cursor: "pointer", position: "relative", background: isActive ? "#0084ff05" : "#fff", border: isActive ? "1px solid #457ffdff" : "1px solid #e5e7eb" }} onClick={() => {
                handleSelectFlight(index)
              }}>


                <span className="status-chip" style={{ position: "absolute", top: "16px", left: "50%", transform: "translateX(-50%)" }}>
                  <span className="status-dot" />
                  {getFlightStatus(flight?.status)}

                </span>

                <span className="select-flight-radio">
                  <input
                    type="radio"

                    name="selectedFlight"
                    checked={isActive || false}
                    readOnly
                    style={{
                      transform: "scale(1.5)",     // size
                      accentColor: isActive ? "#457ffdff" : "gray"  // color
                    }}
                  />
                </span>




                <section className="content">
                  <div className="route" style={{ position: "relative" }}>
                    <div className="ap">
                      {flight?.departure?.iata && <div className="code">{flight?.departure?.iata}</div>}
                      <div className="city">
                        {flight?.departure?.airport}
                      </div>

                    </div>

                    <div className="plane">
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z" />
                      </svg>
                    </div>

                    <div className="ap" style={{ textAlign: "right" }}>
                      <div className="code">{flight?.arrival?.iata}</div>
                      <div className="city">
                        {flight?.arrival?.airport}
                      </div>

                    </div>
                  </div>





                  <div className="new-flight-timing-wrapper">
                    <div style={{ border: "1px solid #ddd" }}>
                      <h5 className="new-flight-timing-title">

                        Departure
                      </h5>
                      <div className="new-flight-timing-grid">
                        <div className="new-flight-timing">
                          <span className="new-flight-timing-label">Scheduled Departure</span>
                          <span className="new-flight-timing-date">{fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal)}</span>
                        </div>

                        {
                          (status !== "C" && status !== "DN" && status !== "S" && status !== "Scheduled") && <div className="new-flight-timing">
                            <span className="new-flight-timing-label">Gate Departure</span>
                            <span className="new-flight-timing-date">{fmt(operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
                          </div>
                        }

                        {
                          (status === "C" || status === "DN" || status === "S" || status === "Scheduled") && <div className="new-flight-timing">
                            <span className="new-flight-timing-label">Estimated Departure</span>
                            <span className="new-flight-timing-date">{fmt(operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
                          </div>
                        }

                        {
                          (status === "A" || status === "L" || status === "D" || status === "R") && <div className="new-flight-timing">
                            <span className="new-flight-timing-label">Takeoff</span>
                            <span className="new-flight-timing-date">{fmt(operationalTimes?.actualRunwayDeparture?.dateLocal || operationalTimes?.estimatedRunwayDeparture?.dateLocal || operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledRunwayDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
                          </div>
                        }

                      </div>

                    </div>

                    <div style={{ border: "1px solid #ddd" }}>
                      <h5 className="new-flight-timing-title">
                        Arrival
                      </h5>
                      <div className="new-flight-timing-grid">
                        <div className="new-flight-timing">
                          <span className="new-flight-timing-label">Scheduled Arrival</span>
                          <span className="new-flight-timing-date">{fmt(operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal)}</span>

                        </div>

                        {
                          (status === 'S' || status === "U" || status === "A" || status === "D" || status === "C" || status === "R" || status === "Scheduled") && <div className="new-flight-timing">
                            <span className="new-flight-timing-label">Estimated Arrival</span>
                            <span className="new-flight-timing-date">{fmt(operationalTimes?.estimatedGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>

                          </div>
                        }

                        {
                          (status === "L") && <div className="new-flight-timing">
                            <span className="new-flight-timing-label">Landing</span>
                            <span className="new-flight-timing-date">{fmt(operationalTimes?.actualRunwayArrival?.dateLocal || operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>

                          </div>
                        }


                        {
                          (status === "L" || status === "D") && <div className="new-flight-timing">
                            <span className="new-flight-timing-label">Gate Arrival</span>
                            <span className="new-flight-timing-date">{fmt(operationalTimes?.actualGateArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal || operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>
                          </div>
                        }

                      </div>

                    </div>
                  </div>
                </section>



              </article>)

            })
          }

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", gap: "15px" }}>
            <Button
              color="blue"
              type="button"
              onClick={handleSaveFlightDetails}
              style={{
                width: "150px"
              }}
              disabled={selectedFlightIndex === null}
            >
              Apply
            </Button>
          </div>

        </div>

      </Modal>
    </div>
  );
};

export default FileaClaim;
